import { Box, Typography } from "@mui/material";
import React from "react";

export default function Label({ label }) {
  return (
    <Box display={"flex"} alignItems={"center"} width={"15%"} flexWrap={"wrap"}>
      <Box display={"flex"} alignItems={"center"}>
        <Typography
          variant="subtitle1"
          sx={{
            marginRight: 1,
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
}
